module.exports = __webpack_public_path__ + "static/media/inscripciones-03.7703b8f5.png";